import { Outlet } from "react-router-dom";

const LoginLayout = () => {
  return (
    <div className="bg-[#001529] bg-[url('/bg.svg')] bg-cover bg-no-repeat w-full h-screen flex justify-center items-center">
      <Outlet />
    </div>
  );
};

export default LoginLayout;
